module.exports = __webpack_public_path__ + "static/media/agenda-placeholder.dc318d4f.jpg";